
<app-alert-html
  [errorHtml]="errorMessage"
  (close)="closeError()"
  >
  
</app-alert-html>
<div class="container-fluid">
  <div class="row">
    <button
      (click)="addTargetButtonClicked()"
      id="addTargetButton"
      class="side-menu-button2"
    >
      + Target
    </button>
  </div>

  <p-table
    id="targets"
    [value]="computedFilteredTargets()"
    #dt
    dataKey="ID"
    [tableStyle]="{ width: '100%' }"
    [loading]="isLoading"
    [rows]="25"
    [rowsPerPageOptions]="[10, 25, 50]"
    [totalRecords]="getTotalTargetsCount()"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="Showing {first}-{last} of {totalRecords} items"
    paginatorTemplate="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
    [paginator]="true"
    [responsive]="true"
    [resizableColumns]="true"
    styleClass="p-datatable-sm"
    [scrollable]="true"
    [scrollHeight]="'flex'"
  >
    <ng-template pTemplate="caption">
      <div class="container text-center" id="targetsFilters">
        <!-- Search Row -->
        <div class="row mb-3">
          <div class="col">
            <span class="p-input-icon-left w-100">
              <i class="pi pi-search"></i>
              <input
                pInputText
                type="text"
                placeholder="Target Name"
                id="searchBarInput"
                class="w-100"
                (ngModelChange)="exitEditModeIfActive()"
                [(ngModel)]="searchKeyword"
              />
            </span>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-12">
            <div class="d-flex flex-wrap gap-3 justify-content-end">
              @if(!activeOnly()) {
                <p-button
                  id="activeTargetsOnlyButton"
                  [style]="{
                    color: '#719eb6',
                    backgroundColor: 'white',
                    border: '2px solid #719eb6',
                    'border-radius': '10px'
                  }"
                  label="Active Only"
                  icon="pi pi-filter"
                  (onClick)="toggleActiveOnly()"
                />
              } @else {
                <p-button
                  id="allTargetStatusesButton"
                  [style]="{
                    color: 'white',
                    backgroundColor: '#719eb6',
                    border: '2px solid white',
                    'border-radius': '10px'
                  }"
                  label="All Statuses"
                  icon="pi pi-filter"
                  (onClick)="toggleActiveOnly()"
                />
              }
            </div>
          </div>
        </div>

        <!-- Collapsible Filters Row -->
        <div class="row mb-3">
          <div class="col-12">
            <div class="d-flex align-items-center">
              <button
                id="filtersButton"
                type="button"
                class="btn btn-link p-0 me-2"
                (click)="toggleFiltersCollapsed()"
                [attr.aria-expanded]="!filtersCollapsed()"
                aria-controls="filtersCollapse"
                style="font-size: 1.2rem; font-weight: bold; color: #719eb6; text-decoration: none;"
              >
                <i class="pi" [class.pi-chevron-right]="filtersCollapsed()" [class.pi-chevron-down]="!filtersCollapsed()"></i>
                Filters
              </button>
            </div>
            
            <div class="collapse" [class.show]="!filtersCollapsed()" id="filtersCollapse">
              <div class="row mt-3">
                <div class="d-flex flex-wrap gap-3">
                  <div>
                    <label for="selectedSkillAreas" class="mt-3 mx-2" style="font-size: 1.2rem; font-weight: bold; color: #719eb6;">Skill Areas: </label>
                    <p-multiSelect appendTo="body"
                                  [options]="this.supervisorHelperService.skillAreas()"
                                  name="selectedSkillAreas"
                                  [(ngModel)]="selectedSkillAreas"
                                  display="chip"
                                  [showClear]="true"
                                  optionLabel="SkillAreaName"
                                  placeholder="Skill Areas">
                    </p-multiSelect>
                  </div>
                  <div>
                    <label for="selectedPlaylists" class="mt-3 mx-2" style="font-size: 1.2rem; font-weight: bold; color: #719eb6;">Playlists: </label>
                    <p-multiSelect appendTo="body"
                                  [options]="getPlaylistOptions()"
                                  name="selectedPlaylists"
                                  [(ngModel)]="selectedPlaylists"
                                  display="chip"
                                  [showClear]="true"
                                  placeholder="Playlists"
                                  optionLabel="PlaylistName">
                    </p-multiSelect>
                  </div>
                  <div>
                    <label for="selectedPrograms" class="mt-3 mx-2" style="font-size: 1.2rem; font-weight: bold; color: #719eb6;">Programs: </label>
                    <p-multiSelect appendTo="body"
                                  [options]="getProgramOptions()"
                                  name="selectedPrograms"
                                  [(ngModel)]="selectedPrograms"
                                  display="chip"
                                  [showClear]="true"
                                  placeholder="Programs"
                                  optionLabel="ProgramName">
                    </p-multiSelect>
                  </div>
                  <div>
                    <label for="selectedStatuses" class="mt-3 mx-2" style="font-size: 1.2rem; font-weight: bold; color: #719eb6;">Statuses: </label>
                    <p-multiSelect appendTo="body"
                                  [options]="possibleStatuses()"
                                  name="selectedStatuses"
                                  [(ngModel)]="selectedStatuses"
                                  display="chip"
                                  [showClear]="true"
                                  placeholder="Status"
                                  optionLabel="label"
                                  optionValue="value">
                    </p-multiSelect>
                  </div>
                  <div>
                    <label for="selectedTargetTypes" class="mt-3 mx-2" style="font-size: 1.2rem; font-weight: bold; color: #719eb6;">Target Types: </label>
                    <p-multiSelect appendTo="body"
                                  [options]="possibleTargetTypes()"
                                  name="selectedTargetTypes"
                                  [(ngModel)]="selectedTargetTypes"
                                  display="chip"
                                  [showClear]="true"
                                  placeholder="Target Type"
                                  optionLabel="label"
                                  optionValue="value">
                    </p-multiSelect>
                  </div>
                  <div>
                    <label for="selectedFavorites" class="mt-3 mx-2" style="font-size: 1.2rem; font-weight: bold; color: #719eb6;">Favorites: </label>
                    <p-multiSelect appendTo="body"
                                  [options]="favoriteOptions()"
                                  inputId="selectedFavorites"
                                  name="selectedFavorites"
                                  [(ngModel)]="selectedFavorites"
                                  (ngModelChange)="exitEditModeIfActive(); dt.first = 0"
                                  display="chip"
                                  [showClear]="true"
                                  placeholder="Favorites"
                                  optionLabel="label"
                                  optionValue="value">
                    </p-multiSelect>
                  </div>
                  <div>
                    <label class="mt-3 mx-2" style="font-size: 1.2rem; font-weight: bold; color: #719eb6;">Opened Date Range: </label>
                    <p-dropdown appendTo="body"
                                [options]="openedDateRangeList()"
                                name="openedDateRange"
                                [(ngModel)]="openedDateRange"
                                display="chip"
                                (ngModelChange)="changedOpenedDateRange()"
                                optionLabel="label"
                                optionValue="value">
                    </p-dropdown>
                  </div>
                  <div *ngIf="isCustomOpenedDateRange()" style="display: inline-flex;">
                    <input type="date" class="mt-3 form-control" [(ngModel)]="openedStartDate" />
                    <input type="date" class="mt-3 form-control" style="margin-left: 5px;" [(ngModel)]="openedEndDate" />
                  </div>
                  <div>
                    <label class="mt-3 mx-2" style="font-size: 1.2rem; font-weight: bold; color: #719eb6;">Probed Date Range: </label>
                    <p-dropdown appendTo="body"
                                [options]="probedDateRangeList()"
                                name="probedDateRange"
                                [(ngModel)]="probedDateRange"
                                display="chip"
                                (ngModelChange)="changedProbedDateRange()"
                                optionLabel="label"
                                optionValue="value">
                    </p-dropdown>
                  </div>
                  <div *ngIf="isCustomProbedDateRange()" style="display: inline-flex;">
                    <input type="date" class="mt-3 form-control" [(ngModel)]="probedStartDate" />
                    <input type="date" class="mt-3 form-control" style="margin-left: 5px;" [(ngModel)]="probedEndDate" />
                  </div>
                  <div>
                    <label class="mt-3 mx-2" style="font-size: 1.2rem; font-weight: bold; color: #719eb6;">Mastered Date Range: </label>
                    <p-dropdown appendTo="body"
                                [options]="masteredDateRangeList()"
                                name="masteredDateRange"
                                [(ngModel)]="masteredDateRange"
                                display="chip"
                                (ngModelChange)="changedMasteredDateRange()"
                                optionLabel="label"
                                optionValue="value">
                    </p-dropdown>
                  </div>
                  <div *ngIf="isCustomMasteredDateRange()" style="display: inline-flex;">
                    <input type="date" class="mt-3 form-control" [(ngModel)]="masteredStartDate" />
                    <input type="date" class="mt-3 form-control" style="margin-left: 5px;" [(ngModel)]="masteredEndDate" />
                  </div>
                  <div>
                    <label class="mt-3 mx-2" style="font-size: 1.2rem; font-weight: bold; color: #719eb6;">Closed Date Range: </label>
                    <p-dropdown appendTo="body"
                                [options]="closedDateRangeList()"
                                name="closedDateRange"
                                [(ngModel)]="closedDateRange"
                                display="chip"
                                (ngModelChange)="changedClosedDateRange()"
                                optionLabel="label"
                                optionValue="value">
                    </p-dropdown>
                  </div>
                  <div *ngIf="isCustomClosedDateRange()" style="display: inline-flex;">
                    <input type="date" class="mt-3 form-control" [(ngModel)]="closedStartDate" />
                    <input type="date" class="mt-3 form-control" style="margin-left: 5px;" [(ngModel)]="closedEndDate" />
                  </div>
                </div>
              </div>
              <div class="row mb-3 mt-3">
                <div class="col-12">
                  <div class="d-flex flex-wrap gap-3 justify-content-end">      
                    <!-- Out of Playlists Button -->
                    @if(!filterByOutOfPlaylists()) {
                      <p-button
                      [style]="{
                        color: '#719eb6',
                        backgroundColor: 'white',
                        border: '2px solid #719eb6',
                        'border-radius': '10px'
                      }"
                      label="Only Out of Playlists"
                      icon="pi pi-list"
                      (onClick)="toggleFilterByOutOfPlaylists()"
                    />
                    } @else {
                      <p-button
                      [style]="{
                        color: 'white',
                        backgroundColor: '#719eb6',
                        border: '2px solid white',
                        'border-radius': '10px'
                      }"
                      label="In/Out of Playlists (Default)"
                      icon="pi pi-list"
                      (onClick)="toggleFilterByOutOfPlaylists()"
                    />
                    }
                    <!-- Out of Programs Button -->
                    @if(!filterByOutOfPrograms()) {
                      <p-button
                      [style]="{
                        color: '#719eb6',
                        backgroundColor: 'white',
                        border: '2px solid #719eb6',
                        'border-radius': '10px'
                      }"
                      label="Only Out of Programs"
                      icon="pi pi-list"
                      (onClick)="toggleFilterByOutOfPrograms()"
                    />
                    } @else {
                      <p-button
                      [style]="{
                        color: 'white',
                        backgroundColor: '#719eb6',
                        border: '2px solid white',
                        'border-radius': '10px'
                      }"
                      label="In/Out of Programs (Default)"
                      icon="pi pi-list"
                      (onClick)="toggleFilterByOutOfPrograms()"
                    />
                    }
      
                    <!-- Include Deleted Button -->
                    @if(!includeDeleted()) {
                    <p-button
                      id="includeDeletedButton"
                      [style]="{
                        color: 'red',
                        backgroundColor: 'white',
                        border: '2px solid red',
                        'border-radius': '10px'
                      }"
                      label="Include Deleted"
                      icon="pi pi-trash"
                      (onClick)="toggleIncludeDeleted()"
                    />
                    } @else {
                    <p-button
                      [style]="{
                        color: 'white',
                        backgroundColor: 'red',
                        border: '2px solid white',
                        'border-radius': '10px'
                      }"
                      label="Exclude Deleted"
                      icon="pi pi-trash"
                      (onClick)="toggleIncludeDeleted()"
                    />
                    } @if(!includeArchived()) {
                    <p-button
                      [style]="{
                        color: '#ffc107',
                        backgroundColor: 'white',
                        border: '2px solid #ffc107',
                        'border-radius': '10px',
                        'min-width': '170px'
                      }"
                      label="Include Archived"
                      icon="pi pi-folder"
                      (onClick)="toggleIncludeArchived()"
                    />
                    } @else {
                    <p-button
                      [style]="{
                        color: 'white',
                        backgroundColor: '#ffc107',
                        border: '2px solid white',
                        'border-radius': '10px',
                        'min-width': '180px'
                      }"
                      label="Exclude Archived"
                      icon="pi pi-folder"
                      (onClick)="toggleIncludeArchived()"
                    />
                    } @if(!includeMastered()) {
                    <p-button
                      [style]="{
                        color: 'green',
                        backgroundColor: 'white',
                        border: '2px solid green',
                        'border-radius': '10px',
                        'min-width': '180px'
                      }"
                      label="Include Mastered"
                      icon="pi pi-check"
                      (onClick)="toggleIncludeMastered()"
                    />
                    } @else {
                    <p-button
                      [style]="{
                        color: 'white',
                        backgroundColor: 'green',
                        border: '2px solid white',
                        'border-radius': '10px',
                        'min-width': '180px'
                      }"
                      label="Exclude Mastered"
                      icon="pi pi-check"
                      (onClick)="toggleIncludeMastered()"
                    />
                    }
                    <p-button
                      label="Clear"
                      [style]="{
                        'border-radius': '10px',
                        border: '2px solid #719eb6'
                      }"
                      icon="pi pi-filter-slash"
                      (click)="clearSearch()"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Order and Selection Row -->
        <div class="row mb-3">
          <div class="col-5">
            <div class="d-flex flex-wrap gap-3 align-items-center">
              <!-- Edit/Done button (only shown when custom order is selected) -->
              @if(orderMode() === 'custom') {
              <p-button
                [label]="isEditMode() ? 'Save' : 'Edit'"
                [icon]="isEditMode() ? 'pi pi-check' : 'pi pi-pencil'"
                [style]="{
                  'border-radius': '10px',
                  border: '2px solid #28a745',
                  color: isEditMode() ? 'white' : '#28a745',
                  backgroundColor: isEditMode() ? '#28a745' : 'white'
                }"
                (onClick)="toggleEditMode()"
              />
              }
              
              <!-- Order dropdown -->
              <div class="d-flex align-items-center gap-2">
                <label style="font-size: 1rem; font-weight: bold; color: #719eb6; margin: 0;">Order:</label>
                <p-dropdown
                  [options]="orderOptions()"
                  [(ngModel)]="orderMode"
                  (ngModelChange)="onOrderModeChange()"
                  optionLabel="label"
                  optionValue="value"
                  [style]="{
                    'min-width': '150px',
                    'border-radius': '10px'
                  }"
                />
              </div>
            </div>
          </div>
          <div class="col-7">
            <div class="d-flex flex-wrap gap-3 justify-content-end">
              @if(!selectingForDeletion){
                <p-button
                label="Select Targets"
                [style]="{
                  backgroundColor: 'white',
                  color:'#719eb6',
                  'border-radius': '10px',
                  border: '2px solid #719eb6'
                }"
                icon="pi pi-wrench"
                (click)="toggleIsSelecting()"
                />
              }
              @else {
              <p-button
                label="Select All"
                [style]="{
                  backgroundColor: 'white',
                  color:'#719eb6',
                  'border-radius': '10px',
                  border: '2px solid #808080'
                }"
                icon="pi pi-check-square"
                (click)="selectAllTargets()"
              />
              <p-button
                [style]="{
                  color: 'red',
                  backgroundColor: 'white',
                  border: '2px solid red',
                  'border-radius': '10px'
                  }"
                label="Delete Targets"
                icon="pi pi-trash"
                [disabled]="targetIDsForDeletion.length === 0"
                (onClick)="deleteSelectedTargets()"
              />
              <p-button
                label="Cancel"
                [style]="{
                  backgroundColor: 'white',
                  color:'#719eb6',
                  'border-radius': '10px',
                  border: '2px solid #808080'
                }"
                icon="pi pi-minus-circle"
                (click)="cancelIsSelecting()"
              />
              }
            </div>
          </div>
        </div>

        <!-- Screen-specific Row -->
        <div class="row mb-3">
          <div class="col-12">
            <div class="d-flex flex-wrap gap-3 justify-content-end">
              <!-- Full Color Targets Button -->
              @if(!fullColorTargets()) {
                <p-button
                  [style]="{
                    color: '#719eb6',
                    backgroundColor: 'white',
                    border: '2px solid #719eb6',
                    'border-radius': '10px'
                  }"
                  label="Full Color Targets"
                  icon="pi pi-palette"
                  (onClick)="toggleFullColorTargets()"
                />
                } @else {
                <p-button
                  [style]="{
                    color: 'white',
                    backgroundColor: '#719eb6',
                    border: '2px solid white',
                    'border-radius': '10px'
                  }"
                  label="Default Colors"
                  icon="pi pi-palette"
                  (onClick)="toggleFullColorTargets()"
                />
              }
            </div>
          </div>
        </div>

        <!-- Selection Status Row -->
        @if(selectingForDeletion){
          <div class="row mb-3">
            <div class="col-12">
              <div class="d-flex justify-content-start align-items-center">
                <em><span>Click Targets To Select</span></em>
              </div>
            </div>
          </div>
        }
      </div>
    </ng-template>

    <ng-template pTemplate="body" let-target>
      @if(orderMode() === 'custom' && isEditMode()) {
      <!-- Edit mode with overlay -->
      <tr class="edit-row">
        <td colspan="100%" class="p-0">
          <div class="edit-container" [id]="'edit-container-' + target.ID">
            <!-- Target content -->
            <div class="target-content">
              <app-target
                [patientID]="patientID()"
                [target]="target"
                [isSelecting]="selectingForDeletion"
                [selectAll]="doSelectAll"
                [id]="target.TargetName"
                [orderMode]="orderMode()"
                [isEditMode]="isEditMode()"
                (moveUp)="moveTargetUp($event)"
                (moveDown)="moveTargetDown($event)"
                (moveToTop)="moveTargetToTop($event)"
                (moveToBottom)="moveTargetToBottom($event)"
                [isExpanded]="isExpandedStatus[target.ID]"
                (isExpandedChange)="onTargetExpandedChange(target.ID, $event)"
                [isIncludeDeletedFilterSelected]="includeDeleted()"
                [isIncludeArchivedFilterSelected]="includeArchived()"
                [isIncludeMasteredFilterSelected]="includeMastered()"
                [isFullColorTargets]="fullColorTargets()"
                (selectTarget)="selectTarget(target.ID)"
              />
            </div>
            
            <!-- Semi-transparent overlay with arrows -->
            <div class="arrow-overlay" [class.moved]="hasPendingChanges(target.ID!)">
              <div class="arrow-row">
                <button 
                  type="button" 
                  class="btn btn-sm arrow-btn"
                  (click)="moveTargetToTop(target.ID!)"
                  [disabled]="isFirstTarget(target.ID!)"
                  title="Move to top">
                  <i class="pi pi-angle-double-up"></i>
                </button>
                <button 
                  type="button" 
                  class="btn btn-sm arrow-btn"
                  (click)="moveTargetUp(target.ID!)"
                  [disabled]="isFirstTarget(target.ID!)"
                  title="Move up one">
                  <i class="pi pi-angle-up"></i>
                </button>
                <button 
                  type="button" 
                  class="btn btn-sm arrow-btn"
                  (click)="moveTargetDown(target.ID!)"
                  [disabled]="isLastTarget(target.ID!)"
                  title="Move down one">
                  <i class="pi pi-angle-down"></i>
                </button>
                <button 
                  type="button" 
                  class="btn btn-sm arrow-btn"
                  (click)="moveTargetToBottom(target.ID!)"
                  [disabled]="isLastTarget(target.ID!)"
                  title="Move to bottom">
                  <i class="pi pi-angle-double-down"></i>
                </button>
              </div>
            </div>
          </div>
        </td>
      </tr>
      } @else {
      <!-- Normal mode -->
      <app-target
        [patientID]="patientID()"
        [target]="target"
        [isSelecting]="selectingForDeletion"
        [selectAll]="doSelectAll"
        [id]="target.TargetName"
        [orderMode]="orderMode()"
        [isEditMode]="isEditMode()"
        (moveUp)="moveTargetUp($event)"
        (moveDown)="moveTargetDown($event)"
        (moveToTop)="moveTargetToTop($event)"
        (moveToBottom)="moveTargetToBottom($event)"
        [isExpanded]="isExpandedStatus[target.ID]"
        (isExpandedChange)="onTargetExpandedChange(target.ID, $event)"
        [isIncludeDeletedFilterSelected]="includeDeleted()"
        [isIncludeArchivedFilterSelected]="includeArchived()"
        [isIncludeMasteredFilterSelected]="includeMastered()"
        [isFullColorTargets]="fullColorTargets()"
        (selectTarget)="selectTarget(target.ID)"
      />
      }
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <p
        style="
          text-align: center;
          margin-top: 20px;
          font-size: 1rem;
          color: #719eb6;
        "
      >
        There are no targets yet.
      </p>
    </ng-template>
  </p-table>
</div>
